






































































import store from '../../store'

export default {
  data () {
    return {
      activeTool: null,
      simple: [
        {
          title: 'How long will the paddock last?',
          path: '/data/entry/simple-pasture-1'
        },
        {
          title: 'How much feed will be available at the end of the grazing period?',
          path: '/data/entry/simple-pasture-2'
        },
        {
          title: 'How many head can I run in this paddock?',
          path: '/data/entry/simple-pasture-3'
        },
        {
          title: 'How many hectares do I need?',
          path: '/data/entry/simple-pasture-4'
        }
      ],
      seasonal: [
        {
          title: 'Summer feed budget',
          path: '/data/entry/seasonal-pasture-1'
        },
        {
          title: 'Winter feed budget',
          path: '/data/entry/seasonal-pasture-2'
        },
        {
          title: 'Rotation planner',
          path: '/data/entry/seasonal-pasture-3'
        }
      ],
      other: [
        {
          title: 'Farm paddock grazing days recorder',
          path: '/data/entry/other-tools-1'
        },
        {
          title: 'Calculate phosphorus required and cost',
          path: '/data/entry/other-tools-2'
        },
        {
          title: 'Feeding supplements at pasture',
          path: '/data/entry/other-tools-3'
        },
        {
          title: 'Compare nitrogen, gibberellic acid and supplement values',
          path: '/data/entry/other-tools-4'
        }
      ]
    }
  },

  // Return to last used tool
  created: function (this:any) {
    if (store.state.activeTool !== null) {
      this.activeTool = store.state.activeTool
      this.routeChange(this.activeTool)
    }
  },

  // Update state on component value changes
  updated: function (this:any) {
    store.dispatch('updateActiveTool', this.activeTool)
  },

  // Update state on component destroy
  beforeDestroy: function (this:any) {
    store.dispatch('updateActiveTool', this.activeTool)
  },

  computed: {
    allItems (this:any) {
      return this.simple.concat(this.seasonal).concat(this.other)
    }
  },

  methods: {
    // Return the currently active tool for simple, seasonal or other
    getActiveTool: function (this:any) {
      this.activeTool = this.allItems[this.allItems.map((e:any) => e.path).indexOf(this.$route.path)]
      return this.activeTool
    },

    // Change the route to the selected tool
    routeChange: function (this:any, item:any) {
      this.$router.push(item.path).catch((err:any) => { console.warn(err) })
    }
  },

  store
}
